/** @format */

export enum ContentfulQueryId {
    CONTENT_HUB_CATEGORIES = 'contentHubCategories',
    LEGAL_PAGES_NAVIGATION = 'legalPagesNavigation',
    ARTICLE_BY_SLUG = 'articleBySlug',
    BASIC_PAGE_BY_SLUG = 'basicPageBySlug',
    GENERAL_PAGE_DATA = 'generalPageData',
    HOMEPAGE_DATA = 'homepageData',
    LANDING_PAGE_HERO_AND_META_BY_SLUG = 'landingPageHeroAndMetaBySlug',
    LANDING_PAGE_CONTENT_BY_SLUG = 'landingPageContentBySlug',
    ORIGINAL_CONTENT_NAV = 'originalContentNav',
    PAGINATED_ARTICLES = 'paginatedArticles',
    PAGINATED_ARTICLES_BY_CATEGORY = 'paginatedArticlesByCategory',
    SITE_CONTENT_META_DATA = 'siteContentMetadataByEntityId',
    SITEWIDE_BANNER_DATA = 'sitewideBannerData',
    CONTENT_BLOCK_COLLECTION = 'contentBlockCollection',
    ENTITY_SPECIFIC_PAGE_DATA = 'entitySpecificPageData',
    CONTENT_CATEGORY_PAGE_DATA_BY_SLUG = 'contentCategoryPageDataBySlug',
    ARTICLE_BY_LEGACY_ID = 'articleByLegacyId',
    ARTICLE_SYS_ID_BY_SLUG = 'articleSysIdBySlug',
    ARTICLE_PAGE_PROPS_BY_SLUG = 'articlePagePropsBySlug',
    GENERIC_PAGE_TYPENAME_BY_SLUG = 'genericPageTypenameBySlug',
    LISTING_TILES = 'listingTiles',
    SITE_CONTENT_META_DATA_BY_SITE_SECTION = 'siteContentMetadataBySiteSection',
    ASSET_BY_ID = 'assetById',
    SITE_CONTENT_SELL_TRUST_BLOCK = 'siteContentSellTrustBlock',
    VIDEO_BLOCK_BY_SITE_SECTION = 'videoBlockBySiteSection',
    HELP_PAGE_CONTENT_BY_SLUG = 'helpPageContentBySlug',
    SITE_CONTENT_HEADER_BY_SITE_SECTION = 'siteContentHeaderBySiteSection',
    AUTHOR_DETAILS_PAGE_BY_SLUG = 'authorDetailsPageBySlug',
}
